export const AEROLINES = [
    { "name": "SKY" },
    { "name": "LATAM" },
    { "name": "COPA" }
]
export const TRASLADO_PRICE = 35
export const ISLA_SAONA = 80
export const SANTO_DOMINGO = 80
export const HOTELS = [
    { "name": "Occidental Caribe 4* Básico" },
    { "name": "Ocean Blue & Sand 4*" },
    { "name": "Impressive Punta Cana 4*" },
    { "name": "Bahía Principe Grand Bávaro 4*" },
    { "name": "Punta Cana Princess 4* - solo adultos" },
    { "name": "Iberostar Waves Dominicana 4* superior" },
    { "name": "Iberostar Waves Punta Cana 4* superior" },
    { "name": "Barceló Bávaro Palace 5*" },
    { "name": "Barceló Bávaro Beach 5* - solo adultos" },
    { "name": "Riu Republica 5* - solo adultos" },
    { "name": "Grand Bávaro Princess 5*" }
]



export const COLUMN_NAMES = {
    VALUES_TO_ASSIGN: 'Por asignar',
    VALUES_ASSIGNED: 'Asignados',
}

export const TABLE_NAMES = {
    TABLE_AEROLINE: "AEROLINE",
    TABLE_HOTEL: "HOTEL"

}

export const STATUS = {
    COTIZADO: "COTIZADO",
    PENDIENTE: "PENDIENTE",
    RESERVADO: "RESERVADO",
    "EN CURSO": "EN CURSO",
    FINALIZADO: "FINALIZADO"
}